module.exports = new __parcel__URL__("View_Icon.11c60661.svg").toString();